import memoizeOne from "memoize-one";

import { Filter } from "constants/filters";
import { reportsFilters } from "constants/reports/filters";
import { NavigationItems } from "constants/reports/navigationItems";
import { recursLabels } from "constants/reports/recurs";
import { ReportType } from "constants/reports/report-type";
import { ISideNavigationItem } from "interfaces/sideNavigationItem";

import { extractRouteFromPathname } from "./routing";

function getRoutesTitleMap(items: ISideNavigationItem[] = NavigationItems()): Record<string, string> {
  return items.reduce<Record<string, string>>(
    (acc, curr) => ({
      ...acc,
      ...(curr.id && curr.name && { [curr.id]: curr.name }),
      ...(curr.children && getRoutesTitleMap(curr.children)),
    }),
    {}
  );
}

function getRoutesPathMap(items: ISideNavigationItem[] = NavigationItems()): Record<string, string> {
  return items.reduce<Record<string, string>>(
    (acc, curr) => ({
      ...acc,
      ...(curr.id && curr.path && { [curr.id]: curr.path }),
      ...(curr.children && getRoutesPathMap(curr.children)),
    }),
    {}
  );
}

const routesPathMap = getRoutesPathMap();
const routesTitleMap = getRoutesTitleMap();

export function getRouteByPathname(pathname: string): string {
  const path = extractRouteFromPathname(pathname);

  // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
  return routesPathMap[path] === pathname ? path : null;
}

export function getRouteBackButtonUrl(pathname: string): string {
  if (pathname.includes("/reports/scheduled-reports/edit/")) {
    return "/reports/scheduled-reports";
  }

  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
  return null;
}

export function getRouteTitleByPathname(pathname: string): string {
  const route = getRouteByPathname(pathname);

  if (pathname && pathname.includes("/reports/scheduled-reports/edit/")) {
    const urlParams = pathname.split("edit/");
    const [type, recurs] = urlParams[1].split("/");
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return `${recursLabels[recurs]} ${type} report`;
  }

  if (!route) return "";

  return routesTitleMap[route] || "";
}

export const getFiltersByReportType = memoizeOne(
  (reportType: ReportType): Filter[] => reportsFilters[reportType] || []
);
